var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('spa-indicator',{staticClass:"cancel-indicator",attrs:{"sequences":_vm.sequences,"currentIndex":_vm.currentIndex}})}
var staticRenderFns = []

export { render, staticRenderFns }